'use client';
import Styles from './payment-error.module.scss';
import { getUsaEpayErrorDetails } from '~/utils/checkout/checkout-errors';
import { Maybe, UsAePayErrorMessage } from '~/gql/__generated__/types';
import { formatPhoneNumber } from '~/utils/utils';
import { wmapStore } from '~/store/wmap-store';
import { isServer } from '~/utils/host';

interface PaymentErrorProps {
  errCode: string | undefined;
  storePhone: string;
  usaEPayErrorMessages: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined;
}

const PaymentError: React.FC<PaymentErrorProps> = ({
  errCode,
  storePhone,
  usaEPayErrorMessages,
}) => {
  if (!errCode) return null;
  const resetSubmitPaymentClicked = wmapStore(
    (state) => state.resetSubmitPaymentClicked,
  );
  const errorDetails = getUsaEpayErrorDetails(errCode, usaEPayErrorMessages);

  if (!errorDetails?.errorMessage) return null;
  const errorMessage = errorDetails.errorMessage.replaceAll(
    '{storePhone}',
    formatPhoneNumber(storePhone),
  );

  if (!isServer) window.scrollTo(0, 0);
  resetSubmitPaymentClicked();

  return (
    <div className={Styles.errorWrapper}>
      <div className="info error">
        <span className="info-icon" />
        <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
      </div>
    </div>
  );
};

export default PaymentError;
